module.exports = __webpack_public_path__ + "static/media/Egg Alternative.8e30e9d6.jpg";